export enum ConstraintsCategory {
  ROOT = "root",

  AMENITIES = "amenities",
  AGRICULTURAL_LAND = "agricultural_land",
  ANCIENT_WOODLAND = "ancient_woodland",
  BIODIVERSITY_IMPROVEMENT = "biodiversity_improvement_areas",
  BUILDING_PERMITS = "us_building_permits",
  COUNCIL_BOUNDARIES = "council_boundaries",
  DEVELOPMENT_SITES = "development_sites_outer",
  ENVIRONMENTAL_PERMITS = "environmental_permits",
  FLUM = "flum",
  HABITATS = "habitats",
  HAZARDS = "hazards",
  LOCAL_PLANNING_AUTHORITY = "local_planning_authority_outer",
  NATIONAL_PARKS = "national_parks",
  NEIGHBOURHOOD_PLAN_AREAS = "neighbourhood_plans",
  LAND_HUB = "land_hub",
  OWNERSHIP_SCOTLAND = "scottish_ownership",
  POLICY = "policy",
  POWER = "power",
  PROTECTED_AREAS = "protected_areas_outer",
  RENEWABLE_ENERGY_PLANNING_DATABASE = "repd",
  REZONING_APPLICATIONS = "rezoning_applications",
  SHLAA = "shlaa",
  SOILS_AND_GEOLOGY = "soils_and_geology",
  SPATIAL_RISK_MULTIPLIERS = "bng_spatial_risk_multipliers",
  SUB_STATIONS = "power_substations",
  US_DEMOGRAPHICS = "us_demographics",
  US_OPPORTUNITY_ZONES = "us_opportunity_zones",
  US_STATE_DEMOGRAPHICS = "us_state_demographics",
  US_TRACT_DEMOGRAPHICS = "us_tract_demographics",
  US_COUNTY_DEMOGRAPHICS = "us_county_demographics",
  ZONING = "zoning",
  UK_DEMOGRAPHICS_LSOA = "uk_demographics_lsoa",
  UK_DEMOGRAPHICS_MSOA = "uk_demographics_msoa",
  UK_DEMOGRAPHICS_LAD = "uk_demographics_lad",
  UK_DEMOGRAPHICS_REGION = "uk_demographics_rgn",
  UK_DEMOGRAPHICS_COUNTRY = "uk_demographics_ctry",
  US_AMENITIES = "us_amenities",
  US_SITE_PLAN_APPLICATIONS = "us_site_plan_applications",
  US_UTILITIES = "us_utilities",
  US_WATER_RESOURCES = "us_water_resources",
  US_URBAN_SERVICE_AREA = "urban_service_area",
  MINING_AND_GEOLOGY = "mining_and_geology",
  GREY_BELT = "grey_belt_land",
  DECLASSIFIED_GREEN_BELT = "declassified_green_belt",
  UK_TERRAIN = "uk_terrain",
  POWER_ECR = "power_ecr",
  DNO_BOUNDARIES = "power_dno_boundaries",
  ROADS_AND_TRAFFIC = "roads_and_traffic",
  ADOPTED_ROADS = "highway_maintenance",
  NEW_TOWNS = "new_towns",
  SDS_AREAS = "proposed_sds_areas",
  LISTED_BUILDINGS = "listed_buildings",
  CONSERVATION_AREAS = "conservation_areas",
  GREENBELT = "greenbelt",
  NATIONAL_LANDSCAPES = "national_landscapes",
  OPEN_LAND_AND_GREEN_SPACES = "open_land_and_green_space",
  SETTLEMENT_BOUNDARIES = "settlement_boundaries",
  ARTICLE_4 = "article_4",
  SAFEGUARDING_SITES = "safeguarding_sites",
  PROTECTED_VIEWS = "protected_views",
  RIGHTS_OF_WAY = "rights_of_way",
  TREE_PRESERVATION_ORDERS = "tree_preservation_orders",
  PLANNING_AUTHORITIES = "planning_authorities",
  BROWNFIELD_LAND = "brownfield_land",
  EMPLOYMENT_AREA = "employment_area",
  FLOOD_ZONES = "flood_zones",
  FLOOD_RISK = "flood_risk",
  SURFACE_WATER_FLOODING = "surface_water_flooding",
  NUTRIENT_NEUTRALITY = "nutrient_neutrality",
  WATER_NEUTRALITY = "water_neutrality",
  DEVELOPMENT_RISK = "development_risk",
  SITE_CHARACTERISATION = "site_characterisation",
}
